import { useState, useEffect } from 'react';
import { useToast } from '../context/ToastContext';

export function useOffline() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { showToast } = useToast();
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        showToast('Connection restored!', 'success');
        setWasOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      showToast('You are offline. Some features may be limited.', 'warning', 5000);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline, showToast]);

  return { isOnline };
}
